import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

dialog {
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
  all: unset;
  user-select: text;
}

/* ------------------------------------*\
    #DRAWER
\*------------------------------------ */
/**
 * 1) a large container that enters from the edge of the screen when triggered by a user.
 *    It’s used to provide users with actions and info without interrupting their flow like a modal.
 * 2) The container element is the backdrop that occupies the full viewport width and height.
 *    This allows for ghosting back the backdrop and handling click events outside the drawer
 */
.cat-c-drawer {
  position: fixed;
  inset-block: 0;
  inset-inline: 0;
  z-index: var(--cat-z-index-500);
  width: 100%;
  height: 100%;
  visibility: hidden;
  opacity: 0;
}
.cat-c-drawer.cat-is-active {
  visibility: visible;
  opacity: 1;
}
.cat-c-drawer.cat-c-side-panel {
  visibility: visible;
  opacity: 1;
  width: 0%;
  height: 0%;
}

/**
 * Right-positioned drawer
   * 1) This makes the show button position to right
*/
.cat-c-drawer.cat-c-drawer--right {
  inset-inline: auto 0;
}

/**
 * Drawer with a dimmed backdrop, similar to a modal background
 */
.cat-c-drawer--backdrop {
  transition: background var(--cat-anim-move-long) var(--cat-anim-ease);
  background: none;
  /**
   * Active drawer with backdrop
   */
}
.cat-c-drawer--backdrop.cat-is-active {
  background: var(--cat-color-dim-60);
}

/**
 * The actual content creator
 */
.cat-c-drawer__panel {
  position: fixed;
  text-align: start;
  width: 100%;
  height: 100%;
  inset-inline-start: 0;
  inset-block-start: 0;
  background-color: var(--cat-theme-color-background-default);
  box-shadow: var(--cat-theme-box-shadow-lg);
  transition: all 0.4s ease;
  transform: translateX(var(--rtlDrawerLeftTranslateX, -100%));
  display: flex;
  flex-direction: column;
  max-width: 100%;
  /**
   * Right-positioned drawer
   * 1) This is the default position
   */
  /**
   * Active left-positioned drawer
   */
  /**
   * Active right-positioned drawer
   */
  /**
   * full WIdth panel for mobile view
   */
}
.cat-c-drawer--size-default .cat-c-drawer__panel {
  width: calc(var(--size-base-unit) * 58);
}
.cat-c-drawer--lg .cat-c-drawer__panel {
  width: calc(var(--size-base-unit) * 87);
}
.cat-c-drawer--right .cat-c-drawer__panel {
  inset-inline: auto 0;
  transform: translateX(var(--rtlDrawerRightTranslateX, 100%));
}
.cat-is-active .cat-c-drawer__panel {
  transform: translateX(0);
  box-shadow: var(--cat-box-shadow-lg);
  outline: none;
}
.cat-c-drawer--right.cat-is-active .cat-c-drawer__panel {
  transform: translateX(0);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-drawer .cat-c-drawer__panel {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}

/**
 * Flip the hide button when active
 */
.cat-is-active .cat-c-drawer__hide-button {
  transform: scaleX(-1);
}

/**
 * Drawer header container
 */
.cat-c-drawer__header {
  padding: var(--cat-space-medium);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-block-end: 1px solid var(--cat-theme-color-border-default);
  position: relative;
}

.cat-c-drawer__header-actions {
  display: block;
  padding-inline-end: var(--cat-space-x-small);
  border-inline-end: 1px solid var(--cat-theme-color-border-default);
}

/**
 * Drawer header content
 */
.cat-c-drawer__header-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-basis: 100%;
}

/**
 * Option hide/show button
 */
.cat-c-drawer__hide-button {
  position: absolute;
  inset-block-start: 0;
  z-index: var(--cat-z-index-100);
  /**
   * Pass down button style updates
   */
  --cat-theme-border-radius: 0;
  --cat-theme-button-width: calc(var(--size-base-unit) * 2.5);
  --cat-button-padding: calc(var(--size-base-unit) * 2.5) 0;
  /**
   * Left aligned
   */
  /**
   * Right aligned
   */
}
.cat-c-drawer__hide-button--left {
  inset-inline-start: calc(var(--size-base-unit) * -2.5);
}
.cat-c-drawer__hide-button--right {
  inset-inline-end: calc(var(--size-base-unit) * -2.5);
}

/**
 * Drawer body container
 * 1) Flex contents to span the available space
 */
.cat-c-drawer__body {
  padding: var(--cat-c-drawer-body-padding, var(--cat-space-medium));
  flex: 1;
  overflow: auto;
}

/**
 * Drawer footer container
 */
.cat-c-drawer__footer {
  padding: var(--cat-space-medium);
  border-block-start: 1px solid var(--cat-theme-color-border-default);
}
.cat-c-drawer--center .cat-c-drawer__footer {
  display: flex;
  justify-content: center;
}

/**
 * Drawer close button
 * The button that appears after the heading
 */
.cat-c-drawer__close-button {
  margin-inline-start: var(--cat-space-x-small);
}

.cat-c-drawer--bottom-wrapper {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1 1 0%;
}

/**
 * Drawer Orientation Bottom
 * Drawer style in mobile view
 */
.cat-c-drawer--orientation-bottom .cat-c-drawer__panel {
  height: auto;
  inset-block: auto 0;
  transform: translate(0, 100%);
  max-width: 100%;
  width: 100vw;
  border-radius: var(--cat-border-radius-lg) var(--cat-border-radius-lg) 0 0;
}
.cat-c-drawer--orientation-bottom.cat-is-active .cat-c-drawer__panel {
  transform: translate(0, 0);
  box-shadow: var(--cat-box-shadow-bottom-drawer);
}
.cat-c-drawer--orientation-bottom .cat-c-drawer__body {
  overflow: visible;
}

.cat-c-drawer--vertical-height-default .cat-c-drawer__panel-wrapper {
  max-height: 50vh;
}

.cat-c-drawer--vertical-height-large .cat-c-drawer__panel-wrapper {
  max-height: 90vh;
}

/**
 * Panel wrapper of the drawer component.
 */
.cat-c-drawer__panel-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.cat-c-drawer:not(.cat-c-drawer--has-actions) .cat-c-drawer__header-actions, .cat-c-drawer:not(.cat-c-drawer--has-footer) .cat-c-drawer__footer, .cat-c-drawer:not(.cat-c-drawer--has-drawer-header-wrapper) .cat-c-drawer__header, .cat-c-drawer:not(.cat-c-drawer--has-default) [part=part-default] {
  display: none;
}
`;
       